import React from 'react';
import { Images } from '../../../../../../../../../shared/app-constants';
import ImageIcon from '../../../../../../../../../shared/components/images/image-icon';
import { FeatureMeta as FeatureMetaProps } from '../../../../../../../../../shared/design-system/components/molecules/all-features-list-modal/types';
import {
  OverlayTooltip,
  Placement,
} from '../../../../../../../../../shared/design-system/components/overlay';

const FeatureMeta: React.FC<FeatureMetaProps> = ({
  isAvailable,
  isComingSoon,
  text,
  tooltipText,
  isLimited,
  limitedAccessTooltipText = '',
}) => {
  let src = Images.CheckSingleGreen;
  let alt = 'Available';

  if (!isAvailable) {
    src = Images.CrossRed;
    alt = 'Not Available';
  }

  if (isLimited) {
    return limitedAccessTooltipText ? (
      <OverlayTooltip
        text={limitedAccessTooltipText}
        placement={Placement.Bottom}
      >
        <p className="m-0 font-14 gray-txt-15 font-medium">Limited Access</p>
      </OverlayTooltip>
    ) : (
      <p className="m-0 font-14 gray-txt-15 font-medium">Limited Access</p>
    );
  }

  if (isComingSoon) {
    return (
      <>
        <p className="m-0 font-14 gray-txt-15 font-medium">Coming Soon</p>
      </>
    );
  }

  if (tooltipText) {
    return (
      <OverlayTooltip text={tooltipText}>
        <span className="m-0 font-14 gray-txt-15 font-medium feature-tooltip pointer">
          {text}
        </span>
      </OverlayTooltip>
    );
  }

  return text ? (
    <span className="m-0 font-14 gray-txt-15 font-medium">{text}</span>
  ) : (
    <ImageIcon src={src} alt={alt} />
  );
};

export const PlansFeatureMeta: React.FC<FeatureMetaProps> = ({
  isAvailable,
  text,
  tooltipText,
  isComingSoon,
  isLimited,
  limitedAccessTooltipText,
  className,
}) => (
  <div
    className={`feature-meta d-flex justify-content-center align-items-center flex-column ${className}`}
  >
    <FeatureMeta
      isAvailable={isAvailable}
      isLimited={isLimited}
      text={text}
      tooltipText={tooltipText}
      isComingSoon={isComingSoon}
      limitedAccessTooltipText={limitedAccessTooltipText}
    />
  </div>
);

export const ProfessionalFeatureMeta: React.FC<FeatureMetaProps> = ({
  isAvailable,
  text,
  tooltipText,
  isComingSoon,
  isLimited,
  limitedAccessTooltipText,
  className,
}) => (
  <div
    className={`feature-meta d-flex justify-content-center align-items-center flex-column professional-bg ${className}`}
  >
    <FeatureMeta
      isAvailable={isAvailable}
      isLimited={isLimited}
      text={text}
      tooltipText={tooltipText}
      isComingSoon={isComingSoon}
      limitedAccessTooltipText={limitedAccessTooltipText}
    />
  </div>
);
